/**
 * @classdesc - FVのイイねICON(カウント数に応じて増減)
 */

import { Application, Container, Assets, Sprite } from "pixi.js";
import Config from "../../config/main.es6";
import FvGoodItem from "./_item.es6";

export default class FvGood {
    constructor() {
        this.DEFAULT_GOOD_NUM = 5;
        this._createNum = 0;
        this.app = null;
        this.target = null;
        this.sprites = [];
        this.texture = null;
        this.renderAnimeCallback = null;
        this._init();
    }

    render(callback = null) {
        this.renderAnimeCallback = callback;
        this._createPixi();
    }

    hide() {
        this.sprites.forEach((item) => {
            item.hide();
        });
    }

    _init() {
        this.target = document.querySelector(".js-fv_good");
        this._createNum = Math.min(300, this._getCreateNum());
    }

    // Goodアイコンの生成数
    _getCreateNum() {
        const hashNum = BOCCHI.hashCount.get();
        let createNum = Math.floor(hashNum / Config.GOOD_PER__ADD);
        if (createNum < this.DEFAULT_GOOD_NUM)
            createNum = this.DEFAULT_GOOD_NUM;
        return createNum;
    }

    async _createPixi() {
        this.app = new Application();
        await this.app.init({ backgroundAlpha: 0, width: 780, height: 1500 });
        this.target.appendChild(this.app.canvas);

        this.texture = await Assets.load(
            "/omnibus/assets/img/page/special/impression/fv/ico_good1_pink.png"
        );
        this._createGoodIco();
    }

    _createGoodIco() {
        if (!this.texture) return;

        let completedAnimations = 0;

        const onComplete = () => {
            completedAnimations++;
            if (completedAnimations === this.sprites.length) {
                this._allAnimationsCompleted();
            }
        };

        for (let i = 0; i < this._createNum; i++) {
            const item = new FvGoodItem(this.app, this.texture);
            this.sprites.push(item);
            item.showAnime(onComplete);
        }
    }

    _allAnimationsCompleted() {
        if (this.renderAnimeCallback) this.renderAnimeCallback();
    }
}
